import React, { Component } from "react";
import ReactDOM from "react-dom";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "material-ui/CircularProgress";
import Paper from "material-ui/Paper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import ReactMarkdown from "react-markdown";
import UiComp from "./UiComp";
import State from "./State";
import AppEvent from "./AppEvent";
import { JSON_SPLASH } from "./splash";
import { JSON_WATCHLIST } from "./watchlist";
import { JSON_SHOPPING } from "./shoppingcart";

class ScreenOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      screen: {},
      start: {},
      end: {}
    };
    this.handleLoad = this.handleLoad.bind(this);
    this.handleStateClick = this.handleStateClick.bind(this);
    this.handleSubStateCloseClick = this.handleSubStateCloseClick.bind(this);
  }

  componentDidMount() {
    this.handleLoad();
  }

  handleLoad(event) {
    this.setState({
      loading: true
    });
    let scr;
    if (this.props.screen === "Splash") scr = JSON_SPLASH;
    else if (this.props.screen === "Watchlist") scr = JSON_WATCHLIST;
    else if (this.props.screen === "Shopping Cart") scr = JSON_SHOPPING;
    var parsedScreen = JSON.parse(scr);

    function convertStateUiEvents(state) {
      if (!state) return;
      if (state.ui)
        for (let j = 0; j < state.ui.length; j++) {
          var ui = state.ui[j];
          convertUiEvents(ui);
        }
    }
    function convert(eventId) {
      //console.log("checking " + eventId)
      for (let j = 0; j < parsedScreen.types.length; j++) {
        if (parsedScreen.types[j].id === eventId)
          //console.log("Found " + parsedScreen.types[j].name);
          return parsedScreen.types[j];
      }
    }
    function convertUiEvents(ui) {
      if (!ui) return;
      if (ui.events) {
        for (let j = 0; j < ui.events.length; j++) {
          ui.events[j] = convert(ui.events[j]);
        }
      }
      if (ui.children) {
        for (let j = 0; j < ui.children.length; j++) {
          var child = ui.children[j];
          convertUiEvents(child);
        }
      }
      if (ui.states) {
        for (let j = 0; j < ui.states.length; j++) {
          var state = ui.states[j];
          convertStateUiEvents(state);
        }
      }
    }
    convertStateUiEvents(parsedScreen.state);
    this.setState({
      loading: false,
      screen: parsedScreen,
      substate: parsedScreen.state.ui[0].children[1].states[1]
    });
  }

  handleStateClick(state) {
    console.log("state click arrived");
    this.setState({ substate: state });
  }

  handleSubStateCloseClick() {
    this.setState({ substate: "" });
  }

  render() {
    var that = this;
    function findEventForId(eventId) {
      function findEvent(localType) {
        return localType.id === eventId;
      }
      let found = that.state.screen.types.find(findEvent);
      console.log("findEventForId " + eventId + " found: " + found);
      return found;
    }
    let uiComps;
    if (!this.state.screen.ui) {
      uiComps = "";
    } else {
      uiComps = (
        <p>
          <UiComp
            comp={this.state.screen.ui}
            localTypes={this.state.screen.types}
            state={this.state.screen.state}
            onGoToState={that.handleStateClick}
          />
        </p>
      );
    }
    let substate;
    if (!this.state.substate) substate = "";
    else {
      console.log("substate showing");
      substate = (
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "fixed",
            display: "block",
            margin: 0,
            zIndex: 10,
            top: 0,
            left: 0,
            paddingTop: "5%",
            background: "#66111111"
          }}
          onClick={this.handleSubStateCloseClick}
        >
          <Paper
            style={{
              padding: 20,
              width: "100%",
              height: "90%",
              textAlign: "left"
            }}
          >
            <State
              state={this.state.substate}
              uievents={this.state.screen.types}
              globals={this.props.globals}
              onGoToState={that.handleStateClick}
            />
          </Paper>
        </div>
      );
    }
    return (
      <div
        style={{
          padding: 20,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div>{substate}</div>
        <div
          className="StateObject"
          style={{
            padding: 10,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Paper style={{ padding: 4, width: "100%", textAlign: "left" }}>
            <State
              state={this.state.screen.state}
              uievents={this.state.screen.types}
              globals={this.props.globals}
              onGoToState={that.handleStateClick}
            />
          </Paper>
        </div>
      </div>
    );
  }
}

export default ScreenOverview;



// WEBPACK FOOTER //
// ./src/components/ScreenOverview.js